<template>
	<div class="machinery_num">
		<p class="item_tab">
			<span :class="[{active: activeId == item.id}]" v-for="(item, index) in itemList" :key="index" @click="tabClick(item)">{{item.name}}</span>
		</p>
		<div class="nj_num">
			<p v-if="activeId == '1'">
				<span>农机总数：</span>
				<span>{{ sumNjNum }}台</span>
			</p>
			<p v-else-if="activeId == '2'">
				<span>智联农机总数：</span>
				<span>{{ sumZlNum }}台</span>
			</p>
			<p v-else>
				<span>农机作业总面积：</span>
				<span>{{ sumWorkArea }}亩次</span>
			</p>
		</div>
		<div>
			<div id="machineryNumEcharts" style="width:99%;height:42vh;" @mouseenter="mEnterChart" @mouseleave="mLeaveChart"></div>
		</div>
	</div>
</template>
<script>
	import Api from '../../../Serves/net-api.js'
	import Http from '../../../Serves/net-http.js'
	import { mapState, mapActions, mapMutations } from "vuex";
	export default {
		components: {

		},
		data() {
			return {
				machineryNumEcharts: '',
				itemList: [{
						id: 1,
						name: '全部农机'
					},
					{
						id: 2,
						name: '智联农机'
					},
					{
						id: 3,
						name: '农机作业'
					}
				],
				activeId: '1',
				areaArr: [],
				coopAreaArr: [],

				imeiNumArr: [],
				perNumArr: [],
				coopNumArr: [],

				zlNumArr: [],
				zlPerNumArr: [],
				zlCoopNumArr: [],

				workAreaArr: [],
				perAreaArr: [],
				coopAreaArr: [],

				areaNameArr: [],
				maxNjNumArr: [],
				maxNumAreaArr: [],
				sumNjNum: 0,
				sumZlNum: 0,
				sumWorkArea: 0,
				timerList: [],
			}
		},
		beforeDestroy() {
			for(let i = 0; i < this.timerList.length; i++) {
				window.clearInterval(this.timerList[i])
			}
		},
		mounted() {
			setTimeout(() => {
				this.homePageNumAndArea()
			}, 500)
			this.$nextTick(() => {
				window.addEventListener('resize', () => {
					this.machineryNumEcharts.resize()
				})

				this.bus.$on('statisticsUserSum', (info) => { //info 接收的参数
					this.sumWorkArea = info
				});

			})

		},
		methods: {
			// 鼠标移入停止滚动
			mEnterChart() {
				for(let i = 0; i < this.timerList.length; i++) {
					window.clearInterval(this.timerList[i])
				}
			},
			// 鼠标移出继续滚动
			mLeaveChart() {
				this.switchHandle()
			},
			switchHandle() {
				let timer = window.setInterval(this.scrollHandle, 5000);
				this.timerList.push(timer)
			},
			scrollHandle() {
				if(this.activeId == 3) {
					this.activeId = 1
				} else {
					this.activeId++
				}
				this.getDataEchart()
			},
			tabClick(item) {
				this.activeId = item.id
				this.getDataEchart()
			},

			homePageNumAndArea() {
				let this_ = this;
				// /homePageStatis/homePageNumAndArea
				// var url=Http.test+'/homePageStatis/homePageNumAndArea'
				// var url=Http.test+'/homePageStatis/homePageNjNumAndWoekArea'
				var url = Http.test + '/homePageStatis/getStatisticsByAreaCode'
				Api.doPost(url, null, false, (res) => {
					var data = res.result.reverse()
					data.forEach((item, index) => {
						this.areaNameArr.push(item.areaName)

						this.imeiNumArr.push(item.njNum) // 农机总数
						this.perNumArr.push(item.perNum) // 个人农机总数
						this.coopNumArr.push(item.coopNum) // 机构农机总数

						this.zlNumArr.push(item.zlNum) // 智联农机总数
						this.zlPerNumArr.push(item.zlPerNum) // 个人智联农机
						this.zlCoopNumArr.push(item.zlCoopNum) // 机构智联农机

						this.workAreaArr.push(Number(item.workArea).toFixed(0)) // 作业面积
						this.perAreaArr.push(item.perArea) // 个人作业面积
						this.coopAreaArr.push(item.coopArea) // 机构作业面积
						this.sumNjNum += item.njNum
						this.sumZlNum += item.zlNum
						//						this.sumWorkArea += item.workArea
					})
					// this.areaNameArr.reverse()
					// this.areaArr.reverse()
					// this.imeiNumArr.reverse()
					// this.coopNumArr.reverse()
					this.getDataEchart()

					this.switchHandle()

				})
			},
			getDataEchart() {
				this.machineryNumEcharts = this.$echarts.init(document.getElementById('machineryNumEcharts'))
				this.machineryNumEcharts.setOption({
					grid: {
						top: '1%',
						left: '5%',
						right: this.areaNameArr.length > 19 ? '6%' : '2%',
						bottom: '1%',
						containLabel: true
					},
					tooltip: {
						show: true,
						trigger: 'axis',
						axisPointer: { // 坐标轴指示器，坐标轴触发有效
							type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
						}
						// formatter: function(params){
						//   console.log(params)
						//   for (var i in params) {
						//     return "<div><p>耕地作业: " + params[i].value +"亩</p></div>"
						//   }
						// },
					},
					dataZoom: [
						//X轴滑动条
						{
							type: 'slider', //滑动条
							show: this.areaNameArr.length > 19 ? true : false, //开启
							yAxisIndex: [0, 1],
							right: '0%', //滑动条位置
							bottom: '6',
							start: this.areaNameArr.length > 19 ? 48 : 0, //初始化时，滑动条宽度开始标度
							end: 100, //初始化时，滑动条宽度结束标度
							width: 20,
						},
						//X轴内置滑动
						{
							type: 'inside', //内置滑动，随鼠标滚轮展示
							yAxisIndex: [0, 1],
							start: 1, //初始化时，滑动条宽度开始标度
							end: 100 //初始化时，滑动条宽度结束标度
						}
					],
					xAxis: {
						splitLine: {
							show: false,
							lineStyle: {
								color: 'rgba(255,255,255,0.3)'
							}
						},
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
						axisLabel: {
							show: false
						}
					},
					yAxis: [{
							type: 'category',
							data: this.areaNameArr,
							axisLine: {
								show: false,
								lineStyle: {
									color: 'rgba(255,255,255,0.3)'
								}
							},
							splitLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								color: '#fff',
								fontSize: 14
							}
						},
						{
							type: 'category',
							position: 'right',
							data: this.activeId == '1' ? this.imeiNumArr : this.activeId == '2' ? this.zlNumArr : this.workAreaArr,
							axisLine: {
								show: false,
								lineStyle: {
									color: 'rgba(255,255,255,0.3)'
								}
							},
							splitLine: {
								show: false
							},
							axisTick: {
								show: false
							},
							axisLabel: {
								show: true,
								color: '#fff',
								// formatter: (params) => {
								//   var danwei = this.activeName === '农机作业' ? params + '亩' : params + '台'
								//   return danwei
								// }
								fontSize: 14
							}
						},
					],
					series: [ //系列列表。每个系列通过 type 决定自己的图表类型
						{
							name: this.activeId == '1' ? '个人农机' : this.activeId == '2' ? '个人智联农机' : '个人作业面积', //系列名称
							type: 'bar', //柱状、条形图
							stack: '总量',
							barWidth: this.areaNameArr.length > 10 ? 13 : 20, //柱条的宽度,默认自适应
							data: this.activeId == '1' ? this.perNumArr : this.activeId == '2' ? this.zlPerNumArr : this.perAreaArr,
							label: { //图形上的文本标签
								show: false,
								position: 'right', //标签的位置
								offset: [15, 0],
								color: 'black', //标签字体颜色
								textStyle: {
									align: 'center',
									baseline: 'middle',
									// fontSize: 14,
									fontWeight: '400',
									color: '#fff',
									textShadowColor: '#000',
									textShadowBlur: '0',
									textShadowOffsetX: 1,
									textShadowOffsetY: 1,
								},
							},
							showBackground: true,
							backgroundStyle: {
								// color: "rgba(180, 180, 180, 0.2)",
								color: '#071892',
								// barBorderRadius: [30, 30, 30, 30]
							},
							itemStyle: { //图形样式
								normal: {
									// barBorderRadius: 10,
									color: '#0b50e8'
								}
							},
							zlevel: 1
						},
						{
							name: this.activeId == '1' ? '机构农机' : this.activeId == '2' ? '机构智联农机' : '机构作业面积', //系列名称
							type: 'bar', //柱状、条形图
							stack: '总量',
							barWidth: this.areaNameArr.length > 10 ? 13 : 20, //柱条的宽度,默认自适应
							data: this.activeId == '1' ? this.coopNumArr : this.activeId == '2' ? this.zlCoopNumArr : this.coopAreaArr,
							label: { //图形上的文本标签
								show: false,
								position: 'right', //标签的位置
								offset: [15, 0],
								color: 'black', //标签字体颜色
								textStyle: {
									align: 'center',
									baseline: 'middle',
									// fontSize: 14,
									fontWeight: '400',
									color: '#fff',
									textShadowColor: '#000',
									textShadowBlur: '0',
									textShadowOffsetX: 1,
									textShadowOffsetY: 1,
								},
							},
							showBackground: true,
							backgroundStyle: {
								// color: "rgba(180, 180, 180, 0.2)",
								color: '#071892',
								// barBorderRadius: [30, 30, 30, 30]
							},
							itemStyle: { //图形样式
								normal: {
									// barBorderRadius: 10,
									color: '#ff7200'
								}
							},
							zlevel: 1
						}
						// {
						//   name: '进度条背景',
						//   type: 'bar',
						//   barGap: '-100%',
						//   barWidth: 19,
						//   // data: this.activeName === '全部农机' ? this.maxNjNumArr : this.maxNumAreaArr,
						//   data: this.coopNumArr,
						//   color: '#071892',//柱条颜色
						//   itemStyle: {
						//     normal: {
						//       // barBorderRadius: 10
						//     }
						//   }
						// }
					]
				})
			}
		}
	}
</script>
<style scoped>
	.item_tab {
		width: 90%;
		height: 4.1vh;
		margin: 0 auto;
		display: flex;
		margin-bottom: 1vh;
		margin-top: 1.5vh;
		border-radius: 0.6vw;
		background: #052293;
	}
	
	.item_tab span {
		width: 50%;
		height: 4.1vh;
		/* text-align: center; */
		/* padding: 1vw; */
		display: inline-block;
		/* background: #052293; */
		text-align: center;
		line-height: 4.1vh;
		/* margin-top: 10px; */
		color: #ffffff;
		font-size: 20px;
		cursor: pointer;
	}
	
	.item_tab span:nth-child(1) {
		border-radius: 0.4vw 0 0 0.4vw;
	}
	
	.item_tab span:nth-child(3) {
		border-radius: 0 0.4vw 0.4vw 0;
	}
	
	.active {
		color: #ffffff;
		font-weight: bold;
		background: #0b50e8;
		color: #f19142;
	}
	
	.nj_num {
		margin: 0 auto;
		width: 90%;
		height: 3.3vh;
		line-height: 3.3vh;
		text-align: center;
	}
	
	.nj_num span {
		color: #ffffff;
		font-size: 18px;
	}
	
	.danwei {
		float: right;
	}
</style>


// WEBPACK FOOTER //
// src/components/Index/view/MachineryNum.vue